import { combineReducers } from "redux";
import { firestoreReducer } from "redux-firestore";
import { firebaseReducer } from 'react-redux-firebase'

export type actionFB = {
    type: string
}

const todoReducer = (state = {}, action: actionFB) => {
    switch (action.type) {
      case 'TodoAdd':        return state;
      case 'TodoDelete':     return state;
      case 'TodoComplete':   return state;
      case 'Error':          return state;
      default:               return state;
    }
};
  

const authReducer = (state = {}, action: actionFB) => {
    switch (action.type) {
      case 'SIGN_IN':        return state;
      case 'SIGN_UP':     return state;
      case 'Error':          return state;
      default:               return state;
    }
};


const rootReducer = combineReducers({
    todoItem: todoReducer,
    firebase: firebaseReducer,
    firestore: firestoreReducer,
    auth: authReducer
});

export default rootReducer;
